import { render } from "./SelectSizeM.vue?vue&type=template&id=3d2e71ac"
import script from "./SelectSizeM.vue?vue&type=script&lang=js"
export * from "./SelectSizeM.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__